// extracted by mini-css-extract-plugin
module.exports = {"wishlistWidget":"WishlistWidgetWrapper-module__wishlistWidget___zvFw8"};